import { gql } from '@apollo/client'
import { VOOH_MEDIA_TREE_FIELDS } from '../../fragments'

export const GET_VOOH_CREATION = gql`
  ${VOOH_MEDIA_TREE_FIELDS}
  query voohCreation($id: ID!) {
    node(id: $id) {
      ... on VoohCreation {
        id
        campaign {
          id
          startDate
          endDate
        }
        details
        mediaFormat
        frameFormat
        deletedAt
        archivedAt
        archiveReason
        hourFrequency
        duration
        creationType
        thumbnailUrl
        file {
          filename
          url
        }
        schedules {
          startDate
          endDate
        }
        mediaTree {
          ...VoohMediaFields
        }
        media {
          id
        }
      }
    }
  }
`
